





import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model} from "vue-property-decorator";
import Editor from '@tinymce/tinymce-vue'
import http from "@/shared/services/http";
@Component({
    name: "TinyMceEditor",
    components: { Editor }
})
export default class extends mixins(CommonMixin) {
    @Model("change") readonly content!: string;

    @Emit("change")
    onchangeContent(val: any) {
        return val;
    }

    initEditor = {
        height: 400,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
            'undo redo | formatselect | bold italic backcolor |' +
            'alignleft aligncenter alignright alignjustify |' +
            'bullist numlist outdent indent | removeformat | help',
        images_upload_handler: (blobInfo, success, failure) => {
            this.uploadImage(blobInfo.blob(), 'article')
                .then((resp) => {
                    console.log(resp);
                    success(resp.data.data.url);
                })
                .catch((error) => failure('Đã có lỗi xảy ra. Vui lòng thử lại'))
        },
        template_cdate_format: '[CDATE: %m/%d/%Y : %H:%M:%S]',
        template_mdate_format: '[MDATE: %m/%d/%Y : %H:%M:%S]',
        image_caption: true,
        image_advtab: true,
        spellchecker_dialog: true,
        spellchecker_whitelist: ['Ephox', 'Moxiecode']
    }

    uploadImage(file, folder) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder);
        return http.post(`${process.env.VUE_APP_BASE_API}v1/upload/by-file`, formData);
    }
}
